export default __webpack_public_path__ + "static/media/close.c801f063.svg";